import React from 'react';
import { connect } from 'react-redux';

import { serializeState, serializeStateFacet } from '../helpers/serializeState';
import { settings } from '../data';

const ConnectedSubmit = props => {
  const { text } = props;

  const createURL = props => {
    let prefix;
    let query;

    if (props['is_federal_employee'] === 'no') {
      prefix = `${settings.listing_page_url}?`;
      query = serializeStateFacet(props);
    } else {
      prefix = `${settings.results_page_url}?`;
      query = serializeState(props);
    }
    return prefix + query;
  };
  return (
    <a href={createURL(props)} className="button button--outline-inverse">
      {text}
    </a>
  );
};

const mapStateToProps = state => {
  return state;
};

const SubmitButton = connect(mapStateToProps)(ConnectedSubmit);

export default SubmitButton;
